exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cross[data-v-5bf4ad5f] {\n  padding-bottom: 2px;\n}\n.noOutline[data-v-5bf4ad5f]:-moz-focus-inner {\n  border: 0px;\n  outline: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5bf4ad5f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/AppSidebar.vue
// module id = lXVe
// module chunks = 1